"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketBeet = exports.Market = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const MarketState_1 = require("../types/MarketState");
const GatingConfig_1 = require("../types/GatingConfig");
const marketDiscriminator = [219, 190, 213, 55, 0, 227, 198, 154];
class Market {
    constructor(store, sellingResource, treasuryMint, treasuryHolder, treasuryOwner, owner, name, description, mutable, price, piecesInOneWallet, startDate, endDate, state, fundsCollected, gatekeeper) {
        this.store = store;
        this.sellingResource = sellingResource;
        this.treasuryMint = treasuryMint;
        this.treasuryHolder = treasuryHolder;
        this.treasuryOwner = treasuryOwner;
        this.owner = owner;
        this.name = name;
        this.description = description;
        this.mutable = mutable;
        this.price = price;
        this.piecesInOneWallet = piecesInOneWallet;
        this.startDate = startDate;
        this.endDate = endDate;
        this.state = state;
        this.fundsCollected = fundsCollected;
        this.gatekeeper = gatekeeper;
    }
    static fromArgs(args) {
        return new Market(args.store, args.sellingResource, args.treasuryMint, args.treasuryHolder, args.treasuryOwner, args.owner, args.name, args.description, args.mutable, args.price, args.piecesInOneWallet, args.startDate, args.endDate, args.state, args.fundsCollected, args.gatekeeper);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return Market.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find Market account at ${address}`);
        }
        return Market.fromAccountInfo(accountInfo, 0)[0];
    }
    static deserialize(buf, offset = 0) {
        return exports.marketBeet.deserialize(buf, offset);
    }
    serialize() {
        return exports.marketBeet.serialize({
            accountDiscriminator: marketDiscriminator,
            ...this,
        });
    }
    static byteSize(args) {
        const instance = Market.fromArgs(args);
        return exports.marketBeet.toFixedFromValue({
            accountDiscriminator: marketDiscriminator,
            ...instance,
        }).byteSize;
    }
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(Market.byteSize(args), commitment);
    }
    pretty() {
        return {
            store: this.store.toBase58(),
            sellingResource: this.sellingResource.toBase58(),
            treasuryMint: this.treasuryMint.toBase58(),
            treasuryHolder: this.treasuryHolder.toBase58(),
            treasuryOwner: this.treasuryOwner.toBase58(),
            owner: this.owner.toBase58(),
            name: this.name,
            description: this.description,
            mutable: this.mutable,
            price: this.price,
            piecesInOneWallet: this.piecesInOneWallet,
            startDate: this.startDate,
            endDate: this.endDate,
            state: 'MarketState.' + MarketState_1.MarketState[this.state],
            fundsCollected: this.fundsCollected,
            gatekeeper: this.gatekeeper,
        };
    }
}
exports.Market = Market;
exports.marketBeet = new beet.FixableBeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['store', beetSolana.publicKey],
    ['sellingResource', beetSolana.publicKey],
    ['treasuryMint', beetSolana.publicKey],
    ['treasuryHolder', beetSolana.publicKey],
    ['treasuryOwner', beetSolana.publicKey],
    ['owner', beetSolana.publicKey],
    ['name', beet.utf8String],
    ['description', beet.utf8String],
    ['mutable', beet.bool],
    ['price', beet.u64],
    ['piecesInOneWallet', beet.coption(beet.u64)],
    ['startDate', beet.u64],
    ['endDate', beet.coption(beet.u64)],
    ['state', MarketState_1.marketStateBeet],
    ['fundsCollected', beet.u64],
    ['gatekeeper', beet.coption(GatingConfig_1.gatingConfigBeet)],
], Market.fromArgs, 'Market');
//# sourceMappingURL=Market.js.map